export class UsersFilterModel {
  public FirstName: string;
  public LastName: string;
  public Email: string;
}
